import React from "react";
import "./FnB1.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card";
import MadisonGrandeimages from "../../../Media/Ruko Paramount/Madison Grande/Madison";
import westvillageimages from "../../../Media/Ruko BSD/West Village/westvillage";
import HamptonEastimages from "../../../Media/Ruko Paramount/Hampton East/HamptonEast";
import HamptonAvenueimages from "../../../Media/Ruko Paramount/Hampton Avenue/Hampton Avenue";
const imageMap = {
  MadisonGrandeimages,
  HamptonEastimages,
  HamptonAvenueimages,
  westvillageimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Briza" className="produk">
      <h1>Ruko Commercial Recomendations for Food & Baverage</h1>
      <h2>Best Choice to Complete Your Business</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
